import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { INotification, NotificationStatus } from "@app/core/interfaces";
import { AuthenticationService } from "@app/core/services";
import { NotificationService } from "@app/core/services/notificaion.service";
import { Subject, takeUntil } from 'rxjs';
import { NotificationHubService } from '@app/core/services/notification-hub.service';
import { BusinessRoutePaths } from '@core/configs/route-paths';


@Component({
    templateUrl: './notification.component.html',
    styleUrls:["./notification.component.css"],
    selector: "app-notification"
})
export class NotificationComponent implements OnInit, OnDestroy {

    public notifications: Array<INotification> = [];
    private unsubscribe$: Subject<void> = new Subject();

    constructor(private notificationService: NotificationService, 
        private authService: AuthenticationService,
        private router: Router,
        private notificationHubService: NotificationHubService) {
    }

    ngOnInit(): void {
        this.notificationService.Get()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: res => {
                   this.notifications = res ?? [];
                }
            });
        this.notificationHubService.startForCurrentUser();
        this.notificationHubService.markAllAsRead$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => this.readAll());
        this.notificationHubService.newNotification$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((data) => this.newNotification(data));

    }

    hasUnreadNotification():boolean{
            return this.notifications?.some(a=>a.status === NotificationStatus.New);
    }


    markAsRead(notification:INotification){
        if(notification.status === NotificationStatus.New){
            notification.status = NotificationStatus.Read;
            this.notificationService.MarkAsRead(notification.id)
                .subscribe({
                    error: () => {
                        notification.status = NotificationStatus.New;
                    }
                });
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    

    newNotification(data: INotification): void {
        if (!data) {
            return;
        }
        this.notifications = [data, ...(this.notifications ?? [])];
        //this.notifications.sort();
    }

    // do not make http calls here, this is called by signalR
    readAll(){
        this.notifications.forEach(n=>{
            if(n.status == NotificationStatus.New){
                n.status = NotificationStatus.Read
            }
        });
    }

   
    markAllAsRead(){
        this.readAll();
        this.notificationService.MarkAllNotificationsAsRead(this.authService.currentUserActiveType)
            .subscribe();
    }

    navigate(notification:INotification){
        this.markAsRead(notification);
        if(notification.userType === "Business"){
            if(notification.appointment){
                this.router.navigate([BusinessRoutePaths.calendar], {queryParams: {appointmentId:notification.appointment.id, startDate:notification.appointment.startDate}} );
            }
        };
    }
}
